/**
 * Dependencies
 */
import React from 'react';
import DocumentTitle from 'react-document-title';

import classes from '@nerdwallet/base-styles/classes';
import classNames from 'classnames';

// Local Components
import VerticalComparison from '../components/front-page/vertical-comparison/vertical-comparison';
import CCBest from '../components/front-page/cc-best/cc-best';
import Testimonials from '../components/front-page/testimonials/testimonials';
import RegistrationModule from '../components/front-page/registration-module/registration-module';

// Other Local Dependencies
import {
  verticalComparisonContent,
  ccBestContent,
  testimonialsContent,
  registrationModuleContent,
} from '../lib/front-page-content';

const FrontPage = () => {
  const documentTitle = 'NerdWallet: Make all the right money moves';

  return (
    <div>
      <DocumentTitle title={documentTitle} />
      <div>
        <div className={classNames([classes('padding-top-4')])}>
          <VerticalComparison {...verticalComparisonContent} />
        </div>
        <RegistrationModule {...registrationModuleContent} />
        <Testimonials {...testimonialsContent} />
        <CCBest {...ccBestContent} />
      </div>
    </div>
  );
};

FrontPage.displayName = 'FrontPage';
FrontPage.analyticsName = 'nw_home_page';

FrontPage.propTypes = {};

export default FrontPage;
